export default {"src":"/_next/static/media/roofing.4716e79b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};